import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';

/* Function */
import ObjGeneral from '../function/';
/* Local store */
import { localStoreFN } from '../../store/localStorage';
/* Actions */
import * as accountSettingActions from '../../actions/account_setting/index';
import * as dashboardActions from '../../actions/dashboard/index';

/* Components */
import Title from '../../components/account_setting/title';
import Form from '../../components/account_setting/form';
import Loading from '../../components/common/loading';
import Message from '../../components/common/message';
import Expired from '../expired/index';

class AccountSetting extends Component {
  constructor(props) {
    super(props);
    this.state = {
      obj: { a: 'foo', b: 'bar', c: [false, 2, null, 'null'] },
      state: null
    };
  }

  async componentDidMount() {
    const permits = localStoreFN().getItem('permits');
    const permit = permits.includes('wizard');
    if (permit) {
      await this.props.actions.fetchAccountSettingApi({});
    } else {
      this.props.history.push('/dashboard/authorization');
    }
  }

  handleSetting = async e => {
    e.preventDefault();
    let text = document.getElementById('setting').value;
    let correctJson = text.replace(/(['"])?([a-z0-9A-Z_]+)(['"]):/g, '"$2": ');
    try {
      JSON.parse(correctJson);
      const obj = {
        key: 'dashboard',
        value: correctJson
      };
      this.setState({ state: true });
      await this.props.actions.handleSetting(obj);
    } catch (err) {
      this.setState({ state: false });
      console.log(err);
    }
  };

  render() {
    let language;
    if (Object.keys(this.props.language).length === 0) {
      language = false;
    } else {
      language = true;
    }
    return (
      <section className="main">
        <div className="main-container">
          {this.props.loading ? (
            <Loading language={!language ? false : this.props.language} />
          ) : this.props.status === 401 ? (
            <Expired
              history={this.props.history}
              language={this.props.language ? this.props.language : ''}
            />
          ) : this.props.status === 200 || this.props.status === 500 ? (
            <div className="container-account">
              <Title state={this.state.state} language={!language ? false : this.props.language} />
              <Form
                datos={this.props.datos}
                obj={this.state.obj}
                handleSetting={this.handleSetting}
                language={!language ? false : this.props.language}
              />
            </div>
          ) : (
            <Message message={this.props.language.error.apiError} />
          )}
        </div>
      </section>
    );
  }
}
const mapStateToProps = state => ({
  datos: state.reducer.accountSetting.datos,
  language: state.reducer.dashboard.language,
  loading: state.reducer.accountSetting.loading,
  status: state.reducer.accountSetting.status
});
const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(accountSettingActions, dispatch),
  dashboardActions: bindActionCreators(dashboardActions, dispatch)
});
AccountSetting.propTypes = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AccountSetting);



// WEBPACK FOOTER //
// ./source/client/containers/account_setting/index.jsx